import React, { FC, useEffect, useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, Icon, IconButton } from '@material-ui/core';
import TestimonialList, { TESTIMONIAL_CARD } from '../../../Features/Testimonial/TestimonialList';
import StyledLabel from '../../../Components/StyledLabel';
import gsap from 'gsap';
import { uniqueId } from 'lodash';
import TestimonialCard from '../../../Features/Testimonial/TestimonialCard';
import useHorizontalList from '../../../Components/HorizontalList/useHorizontalList';
import TESTIMONIALS from '../../../Constants/testimonial.json';
import { useMediaQuery } from '../../../Hooks/useMediaQuery';

export interface TestimonialProps {

}

const Testimonial: FC<TestimonialProps> = (props) => {
    const classes = useStyles();
    const widthToScroll = window.innerWidth / 2;
    const { isDeviceSm } = useMediaQuery();
    const id = uniqueId('testimonial-list');
    const { scrollLeft, scrollRight, isLeftScrollAvailable, isRightScrollAvailable, List } = useHorizontalList({
        itemClass: TESTIMONIAL_CARD,
        margin: 4,
        marginEnd: 4,
        items: TESTIMONIALS,
        renderItem: item => <Box pb={2}><TestimonialCard item={item} /></Box>
    })

    useEffect(() => {
        gsap.fromTo(`.${TESTIMONIAL_CARD}`, {
            opacity: 0,
            x: 200,
        }, {
            scrollTrigger: {
                trigger: `#${id}`,
                toggleActions: 'restart pause',
            },

            opacity: 1,
            duration: 1,
            x: 0,
            ease: "power1.inOut",
            stagger: {
                // from: "edges",
                amount: 0.5
            }
        })

        gsap.to(`.${TESTIMONIAL_CARD}`, {
            scrollTrigger: {
                trigger: `#${id}`,
                scrub: 1,
                toggleActions: 'restart pause',
            },
            position: 'relative',
            left: window.innerWidth < 500 ? 0 : 100,
            stagger: 0.1
        })
    }, [])




    return (
        <section>
            <Box>
                <Box display="flex" mx={isDeviceSm ? 3 : "120px"} flexDirection={isDeviceSm ? 'column' : 'row'} alignItems={isDeviceSm ? "flex-start" : "center"} overflow='auto'>
                    <StyledLabel
                        variant="h3"
                        weight='medium'
                        containerClass={classes.sectionTitleContainer}
                        text='What do our customers say?'
                    />
                    <Box flex={1} />
                    <Box ml={isDeviceSm ? 0 : 4}>
                        <IconButton disabled={!isLeftScrollAvailable} onClick={scrollLeft}><Icon>keyboard_arrow_left</Icon></IconButton>
                        <IconButton disabled={!isRightScrollAvailable} onClick={scrollRight}><Icon>keyboard_arrow_right</Icon></IconButton>
                    </Box>
                </Box>

                <Box id={id} width='100%' overflow='auto' pt={3}>
                    {/* <TestimonialList /> */}
                    {List}
                </Box>
            </Box>
        </section >
    )
}

const useStyles = makeStyles<Theme, any>((theme) => ({
    sectionTitleContainer: {
        position: 'relative',
        width: 800,
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
}));

export default Testimonial;